import { useRouter } from 'next/router'

interface TitleProps {
  job: any
}

const JobTitle: React.FC<TitleProps> = (props: TitleProps) => {
	const { job }: any = props
	const router = useRouter()
	const locale: string = router.locale as string
	if (locale === 'sg') {
		return <h2>{job.title}</h2>
	} else {
		if (locale === 'zh') {
			if (job.titleChinese !== null) {
				return <h2>{job.titleChinese}</h2>
			} else {
				return <h2>{job.title}</h2>
			}
		} else if (locale === 'my') {
			if (job.titleMalay !== null) {
				return <h2>{job.titleMalay}</h2>
			} else {
				return <h2>{job.title}</h2>
			}
		} else {
			return <h2>{job.title}</h2>
		}
	}
}

export default JobTitle
